import MainTitle from "../../components/ui/MainTitle/MainTitle";
import CustomButton from "../../components/ui/CustomButton/CustomButton";
import plusIconWhite from "../../assets/images/icons/plus-white.svg";
import { Form, FormInstance, Table, TableProps } from "antd";
import React, { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useGetAllClassesCategoriesQuery } from "../../api/queries";
import FormItemInput from "../../components/ui/FormItemInput/FormItemInput";
import searchIconWhite from "../../assets/images/icons/search-icon-white.svg";
import { ColumnsType } from "antd/es/table";
import editIcon from "../../assets/images/icons/edit-dark.svg";
import { IClassCategory } from "../../models/ClassCategory";
import CreateCategoryPopup from "./CreateCategoryPopup/CreateCategoryPopup";

const ClassesCategories = () => {
  const formRef = useRef<FormInstance>(null);
  const { t } = useTranslation();

  const [showCreateCategoryPopup, setShowCreateCategoryPopup] = useState<boolean>(false);
  const [selectedCategoryForEdit, setSelectedCategoryForEdit] = useState<IClassCategory | null>(
    null
  );
  const [tableParams, setTableParams] = useState<{ current: number; pageSize: number }>({
    current: 1,
    pageSize: 10,
  });
  const [filters, setFilters] = useState<{ searchValue: string | null }>({ searchValue: null });
  const {
    data: categories = [],
    isLoading,
    refetch,
  } = useGetAllClassesCategoriesQuery(filters.searchValue);

  const handleTableChange: TableProps<IClassCategory>["onChange"] = (pagination) => {
    setTableParams({
      current: pagination.current || 1,
      pageSize: pagination.pageSize || 10,
    });
  };

  const onFinish = (values: { searchValue: string | undefined }) => {
    const model = {
      searchValue: values.searchValue ? values.searchValue : null,
    };
    setFilters(model);
  };

  const closePopup = () => {
    setShowCreateCategoryPopup(false);
    setSelectedCategoryForEdit(null);
  };

  const columns: ColumnsType<IClassCategory> = [
    {
      title: t("CategoryName"),
      render: (data: IClassCategory) => {
        return data.name;
      },
    },
    {
      title: t("Action"),
      width: "10%",
      render: (data: IClassCategory) => {
        return (
          <div>
            <button
              style={{
                display: "inline-flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "6px",
                fontFamily: "Open Sans",
                fontSize: "16px",
              }}
              onClick={() => {
                setShowCreateCategoryPopup(true);
                setSelectedCategoryForEdit(data);
              }}
            >
              <img src={editIcon} alt={"edit"} />
              {t("Edit")}
            </button>
          </div>
        );
      },
    },
  ];

  return (
    <div className={"page-content gyms-page"}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginBottom: "20px",
        }}
      >
        <MainTitle text={t("ServicesCategories")} />
        <CustomButton
          text={t("AddNew")}
          type={"button"}
          typeStyle={"fill"}
          icon={plusIconWhite}
          altIcon={"add"}
          functionOnClick={() => setShowCreateCategoryPopup(true)}
          style={{ marginBottom: "16px", width: "180px" }}
        />
      </div>

      <div className={"top-row"}>
        <Form
          className={"form"}
          ref={formRef}
          name="gym-listing-filter"
          onFinish={onFinish}
          autoComplete="off"
          layout={"vertical"}
        >
          <FormItemInput
            name={"searchValue"}
            label={t("Search")}
            rules={{ required: false }}
            placeholder={t("SearchByCategoryName")}
            style={{
              width: "30%",
            }}
          />
          <div className={"btn-wrapper"}>
            <CustomButton
              text={""}
              type={"submit"}
              typeStyle={"fill"}
              icon={searchIconWhite}
              altIcon={"search"}
            />
          </div>
        </Form>
      </div>

      <Table
        className={"table"}
        columns={columns}
        rowKey={(record) => record.id}
        dataSource={categories}
        pagination={{ ...tableParams, total: categories.length }}
        loading={isLoading}
        onChange={handleTableChange}
      />

      {showCreateCategoryPopup && (
        <CreateCategoryPopup
          closePopup={closePopup}
          item={selectedCategoryForEdit}
          getData={refetch}
        />
      )}
    </div>
  );
};

export default ClassesCategories;
